import { render } from "./SidenavHeader.vue?vue&type=template&id=47480101"
import script from "./SidenavHeader.vue?vue&type=script&lang=js"
export * from "./SidenavHeader.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__